import { useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { loadTossPayments } from "@tosspayments/tosspayments-sdk";
import styled from "styled-components";
import Lottie from 'lottie-react-web';
import moment from "moment";

// Model //
import FetchModule from "../../../Model/Network/FetchModule";
// Model //

// Animation //
import LoadingAnimation from '../../../Animation/LoadingAnimation.json';
// Animation //

export default function GlobalPaymentRequestPage() {
  const navigate = useNavigate();
  const params = useParams();
  

  // const TosspaymentsKey = 'test_ck_DpexMgkW36bGK222yGB43GbR5ozO';
  const TosspaymentsKey = 'live_ck_AQ92ymxN34Zn669xmQ9KrajRKXvd';
  const url = 'https://tournament.link-coach.io';
  // const url = 'http://192.168.0.101:8080';

  // 카드 등록을 위한 토클 발행 후 카드 등록 실행 //
  useEffect(() => {
    window.localStorage.setItem('Token', 'Bearer ' + params.token);
    
    let merchantUid = params.merchantUid;
    let itemName = params.itemName;

    const fetchModule = new FetchModule();
    (
      async() => {
        const responseData = await fetchModule.getDataOfEventVer2('sales/payment_data/' + merchantUid, 'GET');
        // console.log(responseData);
        if (responseData.status === 200) {
          let merchantUid = responseData.data.merchantUid;
          let userName = responseData.data.userName;
          let phone = responseData.data.phone;
          let email = responseData.data.email;
          let userId = responseData.data.userId;
          let countryCode = responseData.data.countryCode;
          let paymentCode = responseData.data.paymentCode;
          let priceUsd = responseData.data.priceUsd;
          
          let firstName = '';
          let lastName = '';

          // 1. null / undefined / 숫자 등 방어
          const fullName = userName.trim();

          // 2. 공백 기준 분리
          const parts = fullName.split(/\s+/).filter(Boolean);

          // 3. 한 덩어리일 때 (공백 없음 / 한 글자 포함)
          if (parts.length === 1) firstName = parts[0];
          // 4. 두덩어리 이상일때 
          else if (parts.length > 2) {
            firstName = parts.slice(0, -1).join(" ");
            lastName = parts[parts.length - 1];
          }
          
          const tossPayments = await loadTossPayments(TosspaymentsKey);
          const payment = tossPayments.payment({ customerKey: TosspaymentsKey });

          // 컴포넌트 마운트 시 자동으로 결제창 실행
          await payment.requestPayment({
            method: "FOREIGN_EASY_PAY",
            amount: {
              currency: "USD",
              value: priceUsd,
            },
            orderId: merchantUid,
            orderName: itemName,
            successUrl: url + "/api2/sales/global_payment/tosspayments/success",
            failUrl: url + "/api2/sales/global_payment/tosspayments/fail",
            customerEmail: email,
            customerName: userName,
            customerMobilePhone: phone,
            foreignEasyPay: {
              provider: "PAYPAL",
              country: paymentCode,
              paymentMethodOptions: {
                paypal: {
                  setTransactionContext: {
                    sender_account_id: userId,
                    sender_first_name: firstName,
                    sender_last_name: lastName,
                    sender_email: email,
                    sender_phone: "(" + countryCode + ")" + phone,
                    sender_country_code: paymentCode,
                    sender_create_date: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                  },
                },
              },
            },
          });
        }
        else if (responseData.status === 201) {
          navigate('/payment/global/complete/201/' + params.error + '/' + params.merchantUid);
        }
        else if (responseData.status === 202) {
          navigate('/payment/global/complete/202/Registration is full/' + params.merchantUid);
        }
        else if (responseData.status === 203) {
          navigate('/payment/global/complete/203/Payment already completed/' + params.merchantUid);
        }
        else if (responseData.status === 401) {
          navigate('/payment/global/complete/401/No payment data found/' + params.merchantUid);
        }
        else if (responseData.status === 402) {
          navigate('/payment/global/complete/402/Payer information does not match/' + params.merchantUid);
        }
        else {
          navigate('/payment/global/complete/400/Failed to load payment module/' + params.merchantUid);
        }
      }
    )();
  }, [TosspaymentsKey]);

  return (
    <TopLevelWrapper >
      <LottieWrapper>
        <LottieBox>
          <Lottie options={{ animationData: LoadingAnimation }} />
        </LottieBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000'>결제 모듈 로딩중...</Text>
      </LottieWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;

  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const LottieBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 60px;
  height: 60px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize};

  color: ${props => props.color};

  margin: 0 0 0 0;
`;